module.exports = __webpack_public_path__ + "static/media/lumbering10.a908cbf2.jpg";